import * as React from 'react';

const MehOutlineIcon = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}>
      <path
        d="M5.74862 8.00114C6.16369 8.00114 6.50017 7.66466 6.50017 7.24959C6.50017 6.83453 6.16369 6.49805 5.74862 6.49805C5.33355 6.49805 4.99707 6.83453 4.99707 7.24959C4.99707 7.66466 5.33355 8.00114 5.74862 8.00114Z"
        fill="currentColor"
      />
      <path
        d="M5.68652 10.7476H10.3104"
        stroke="black"
        strokeWidth="0.999764"
        strokeLinecap="round"
      />
      <path
        d="M10.2496 8.00114C10.6647 8.00114 11.0011 7.66466 11.0011 7.24959C11.0011 6.83453 10.6647 6.49805 10.2496 6.49805C9.83453 6.49805 9.49805 6.83453 9.49805 7.24959C9.49805 7.66466 9.83453 8.00114 10.2496 8.00114Z"
        fill="currentColor"
      />
      <path
        d="M7.99944 14.4964C11.5884 14.4964 14.4979 11.587 14.4979 7.99798C14.4979 4.40897 11.5884 1.49951 7.99944 1.49951C4.41044 1.49951 1.50098 4.40897 1.50098 7.99798C1.50098 11.587 4.41044 14.4964 7.99944 14.4964Z"
        stroke="currentColor"
        strokeWidth="0.999764"
        strokeMiterlimit="10"
      />
    </svg>
  );
});

export default MehOutlineIcon;
